<template>
  <div class="auth-card-wrapper">
    <div class="auth-card">
      <div class="auth-card-container">
        <img
          class="logo"
          alt="logo"
          src="@/assets/nubuilder.svg"
        />
        <h3 class="text-title">Sign up with your email address.</h3>
      </div>

      <div class="auth-card-container">
        <v-form ref="form" v-model="valid">
          <div class="auth-card-container form-fields" style="margin-bottom: 8px">
            <v-text-field
              autofocus
              name="firstname"
              validate-on="blur"
              v-model="firstname"
              :maxLength="40"
              hint="At most 40 characters"
              :rules="[rules.required]"
              variant="outlined"
              density="default"
              label="First Name"
            >
            </v-text-field>

            <v-text-field
              name="lastname"
              validate-on="blur"
              v-model="lastname"
              :maxLength="40"
              hint="At most 40 characters"
              :rules="[rules.required]"
              variant="outlined"
              density="default"
              label='Last Name'
            >
            </v-text-field>

            <v-text-field
              name="phoneNumber"
              label="Phone number"
              validate-on="blur"
              v-model="phoneNumber"
              :maxLength="25"
              :rules="[rules.phoneNumber]"
              variant="outlined"
              density="default"
              hint="Must start with a + sign followed by country code and numbers without spaces or punctuation"
            ></v-text-field>

            <v-text-field
              name="organisation"
              label="Organisation"
              validate-on="blur"
              v-model="company"
              :maxLength="100"
              :rules="[rules.required]"
              hint="An organisation is an entity that runs one or several development projects"
              variant="outlined"
              density="default"
            >
            </v-text-field>

            <v-text-field
              name="email"
              label="Email"
              type="email"
              autocomplete="none"
              validate-on="blur"
              :maxLength="254"
              v-model="email"
              :rules="[rules.required, rules.email]"
              variant="outlined"
              density="default"
            >
            </v-text-field>

            <v-text-field
              id="password"
              name="password"
              autocomplete="new-password"
              counter
              v-model="password"
              :maxLength="254"
              :append-inner-icon="e1 ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append-inner="() => (e1 = !e1)"
              :type="e1 ? 'password' : 'text'"
              :rules="[rules.required]"
              min="8"
              label="Password"
              hint="At least 8 characters, requires a mix of characters and numbers"
              variant="outlined"
              density="default"
            >
            </v-text-field>

            <v-textarea
              name="referralSource"
              label="How did you hear about us?"
              validate-on="blur"
              v-model="referralSource"
              :maxLength="100"
              :rules="[rules.minCharacters]"
              variant="outlined"
              density="default"
              hint="At most 100 characters"
            >
            </v-textarea>

            <v-textarea
              name="usageIntent"
              label="How do you intend to use NuBuilder?"
              validate-on="blur"
              v-model="usageIntent"
              :maxLength="250"
              variant="outlined"
              density="default"
              hint="At most 250 characters"
            >
            </v-textarea>

            <v-checkbox v-model="checkbox" :rules="[rules.terms]" class="d-inline-block mt-0">
              <template v-slot:label>
                <div>
                  I agree to the
                  <strong
                  ><u
                  ><a
                    onclick="window.open('../../Qlerify_terms_of_service_and_privacy_policy.pdf','_blank');"
                    href="#"
                  >Terms of Service & Privacy Policy</a
                  ></u
                  ></strong
                  >
                </div>
              </template>
            </v-checkbox>

            <p class="message bg-error" v-html="error" v-if="error"/>
            <p class="message bg-indigo" v-html="message" v-if="message"/>
          </div>

          <div class="auth-card-container">
            <div class="auth-card-footer justify-space-between">
              <div class="auth-card-footer-part">
                <p class="text">
                  Already have an account?
                  <router-link
                    class="text text-decoration-none"
                    tabindex="5"
                    :to="{ path: '/login' }"
                  >
                    <span class="light--text">Log in</span>
                  </router-link>
                </p>
              </div>
              <div class="auth-card-footer-part">
                <v-btn rounded="lg" size="large" color="#363a40" class="ml-auto d-flex" variant="flat" @click="submit"
                       tabindex="3">
                  Create account
                </v-btn>
              </div>
            </div>
          </div>
        </v-form>
        <div class="auth-card-container">
          <text-divider text="or" class="mr-n2"/>
          <google-sign-in-button isForSignUp/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import GoogleSignInButton from '@/components/GoogleSignInButton.vue'
import TextDivider from '@/components/TextDivider.vue'

export default {
  components: { TextDivider, GoogleSignInButton },
  data () {
    return {
      checkbox: false,
      dialog: false,
      e1: true,
      email: '',
      error: null,
      message: null,
      firstname: '',
      lastname: '',
      password: '',
      referralSource: '',
      usageIntent: '',
      company: null,
      phoneNumber: null,
      rules: {
        required: (value) => !!value || 'Required',
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail'
        },
        phoneNumber: (value) => {
          const pattern = /^\+[1-9]\d{1,14}$/
          return !value || pattern.test(value) || 'Invalid phone number. Must start with a + sign followed by country code and numbers without spaces or punctuation'
        },
        terms: (value) => value || 'You must agree to continue!',
        minCharacters: (value) => (value && value.length >= 10) || 'Please enter at least 10 characters'
      },
      valid: true
    }
  },
  methods: {
    async submit () {
      const { valid } = await this.$refs.form.validate()
      if (valid) {
        this.$cognitoAuth.signup(this.firstname, this.lastname, this.company, this.phoneNumber, this.email, this.password, this.referralSource, this.usageIntent, (err, result) => {
          if (err) {
            if (err.message.includes('Invalid phone number format.')) {
              err.message = 'Invalid phone number format or invalid country code.'
            }
            this.error = err.message
          } else {
            this.$router.replace({
              path: '/confirm',
              query: { username: this.email, projectId: this.$route.query.projectId }
            })
          }
        })
      } else {
        this.error = 'One or more fields are invalid.'
      }
    }
  }
}
</script>

<style scoped>
.text {
  color: #1D1F22;
  font-size: 13px;
  text-align: left;
  margin-bottom: 0;
  line-height: 14.3px;
}

.text-decoration-none {
  text-decoration: none;
}

.logo {
  width: 110px;
  height: 48px;
  margin-bottom: 24px;
}

.form-fields {
  gap: 12px;
  display: flex;
  flex-direction: column;
}

.message {
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
}
</style>
